import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/core';
import React from 'react';
import WalletUnlock from './WalletUnlock';

const WalletUnlockModal = () => (
  <Modal isOpen={true} onClose={() => null} isCentered>
    <ModalOverlay>
      <ModalContent>
        <ModalBody textAlign="center" p={4}>
          <WalletUnlock onNext={() => 'unlocked!'} />
        </ModalBody>
      </ModalContent>
    </ModalOverlay>
  </Modal>
);

export default WalletUnlockModal;
